@if (loaderService.isLoading()) {
  <div class="loader-wrapper">
    <span class="loader"></span>
  </div>
}
